export default __webpack_public_path__ + "static/media/games.5ab61576.svg";